
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38.2 38.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.1.5A18.6 18.6 0 11.5 19.1 18.6 18.6 0 0119.1.5z","fill":"none","stroke":"#ffa635","stroke-dasharray":"3 2"}}),_c('circle',{attrs:{"cx":"19.06","cy":"19.06","r":"6.25","fill":"#ffa635"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/network/sdu.svg